export const rentStatuses = {
    IN_PROGRESS: {
        color: "#10B981",
        soft: "rgba(16, 185, 129, 0.14)",
        text: "words.in_progress",
    },
    SCHEDULED: {
        color: "#3B82F6",
        soft: "rgba(59, 130, 246, 0.14)",
        text: "words.booked",
    },
    OVERDUE: {
        color: "#EF4444",
        soft: "rgba(239, 68, 68, 0.14)",
        text: "words.overdue",
    },
    FINISHED: {
        color: "#94A3B8",
        soft: "rgba(148, 163, 184, 0.18)",
        text: "words.completed",
    },
    CANCELED: {
        color: "#F59E0B",
        soft: "rgba(245, 158, 11, 0.16)",
        text: "words.cancelled",
    },
    CLOSED: {
        color: "#94A3B8",
        soft: "rgba(148, 163, 184, 0.18)",
        text: "words.closed",
    },
};
